import { Facet } from '@Types/result/Facet';
import { fetchApiHub } from 'frontastic/lib/fetch-api-hub';

export const getFacetValues = async (facets: string | string[]): Promise<Facet | Facet[]> => {
  return await fetchApiHub('/action/search/getFacetValues', { method: 'POST' }, { facets });
};
